import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Button,
  FormHelperText,
  IconButton,
  Input,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useState } from 'react';

import { errorToast } from '../../helpers';
import { MasterData } from '../../types/General';
import { UploadMedia } from '../../utils/mediaUpload';
import { isValidInput } from '../../utils/validations';

const carFeatures = [
  { id: 1, name: 'ABS', icon: '⚙️' },
  { id: 2, name: 'Electric Starter', icon: '🪑' },
  { id: 3, name: 'Topcase', icon: '📷' },
  { id: 4, name: 'Windshield', icon: '🛠️' },
];
type props = {
  formik: any;
  masterData: MasterData | undefined;
  fleetDamage: any;
  setFleetDamage: any;
  features: any;
  setFeatures: any;
  carImages: string[];
  setCarImages: Dispatch<SetStateAction<string[]>>;
  coverImage: string;
  setCoverImage: Dispatch<SetStateAction<string>>;
  accidentHistory: boolean;
  setAccidentHistory: Dispatch<SetStateAction<boolean>>;
};
const BikeForm = ({
  accidentHistory,
  carImages,
  coverImage,
  features,
  fleetDamage,
  formik,
  masterData,
  setAccidentHistory,
  setCarImages,
  setCoverImage,
  setFeatures,
  setFleetDamage,
}: props) => {
  const [carImage, setCarImage] = useState('');

  const [brand, setBrand] = useState<any>('default');
  const [bodyType, setBodyType] = useState('default');

  const [fuelType, setFuelType] = useState('default');

  const [driveType, setDriveType] = useState('default');

  const [engineCapacity, setEngineCapacity] = useState('default');

  const [exteriorColor, setExteriorColor] = useState('default');

  const [warranty, setWarranty] = useState('default');

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const handleBrandChange = (event: SelectChangeEvent) => {
    setBrand(event.target.value as any);
  };
  const handleBodyTypeChange = (event: SelectChangeEvent) => {
    setBodyType(event.target.value as any);
  };

  const handleFuelType = (event: SelectChangeEvent) => {
    setFuelType(event.target.value as any);
  };

  const handleDriveType = (event: SelectChangeEvent) => {
    setDriveType(event.target.value as any);
  };

  const handleEngineCapacity = (event: SelectChangeEvent) => {
    setEngineCapacity(event.target.value as any);
  };

  const handleExteriorColor = (event: SelectChangeEvent) => {
    setExteriorColor(event.target.value as any);
  };
  const handleWarrantyChnage = (event: SelectChangeEvent) => {
    setWarranty(event.target.value as any);
  };

  const handleCarUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    // if (Array.from(files || []).length > 20) {
    //   errorToast("Max limit is upto 20 images");
    //   event.target.value = "";
    //   return;
    // }

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const invalidFiles = Array.from(files || []).filter(
      (file) => !allowedTypes.includes(file.type)
    );
    if (invalidFiles.length > 0) {
      errorToast('Inavlid  type');
      event.target.value = '';
      return;
    }
    const resArray = await Promise.all(
      Array.from(files || []).map(async (file) => {
        if (allowedTypes.includes(file.type)) {
          return UploadMedia(file);
        }
      })
    );

    resArray.map((res) => {
      if (res?.statusCode === 200) {
        setCarImages((prevImages) => [...prevImages, res?.data?.image]);

        event.target.value = '';
      } else {
        event.target.value = '';
      }
    });
  };

  const handleCoverUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : '';
    // if (Array.from(files || []).length > 20) {
    //   errorToast("Max limit is upto 20 images");
    //   event.target.value = "";
    //   return;
    // }
    if (
      file &&
      file.type &&
      file.type !== 'image/jpeg' &&
      file.type !== 'image/jpg' &&
      file.type !== 'image/png'
    ) {
      errorToast('Invalid image type');
      return;
    }

    const images = await UploadMedia(file);
    if (images?.statusCode === 200) {
      setCoverImage(images?.data?.image);
      event.target.value = '';
    }
  };

  const handleRemove = (index: number) => {
    const updatedImages = carImages.filter((_, i) => i !== index);
    setCarImages(updatedImages);
  };
  return (
    <>
      {/* Car Image */}
      <div className="control_group w_50">
        <label>Image</label>
        <div className="upload_box_bnr">
          {carImages?.length
            ? carImages.map((image, index) => (
                <label key={index}>
                  <IconButton className="crossIcon" onClick={() => handleRemove(index)}>
                    <CloseIcon />
                  </IconButton>
                  <figure>
                    <img src={image || '/static/images/picture.png'} alt="Upload" />
                  </figure>
                </label>
              ))
            : null}

          <label>
            <figure>
              <img src={'/static/images/picture.png'} alt="Upload" />
            </figure>
            <IconButton className="uploadIcon">
              <label htmlFor="icon-button-file">
                <Button component="span" className="upload_image_btn">
                  <img src="/static/images/edit2_icon.svg" alt="Upload" />
                  <Input
                    sx={{ display: 'none' }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: 'image/png,image/jpeg',
                      multiple: true,
                    }}
                    onChange={(e: any) => {
                      handleCarUpload(e);
                      e.target.value = null;
                    }}
                  />
                </Button>
              </label>
            </IconButton>
          </label>
        </div>
      </div>
      {/* Cover Image */}
      <div className="control_group w_100">
        <label>Cover Image</label>
        <div className="upload_box_bnr">
          <label>
            {coverImage && (
              <IconButton className="crossIcon" onClick={() => setCoverImage('')}>
                <CloseIcon />
              </IconButton>
            )}
            <figure>
              <img src={coverImage ? coverImage : '/static/images/picture.png'} alt="Upload" />
            </figure>
            <IconButton className="uploadIcon">
              <label htmlFor="icon-button-file-cover">
                <Button component="span" className="upload_image_btn">
                  <img src="/static/images/edit2_icon.svg" alt="Upload" />
                  <Input
                    sx={{ display: 'none' }}
                    id="icon-button-file-cover"
                    type="file"
                    inputProps={{
                      accept: 'image/png,image/jpeg',
                    }}
                    onChange={(e: any) => {
                      handleCoverUpload(e);
                      e.target.value = null;
                    }}
                  />
                </Button>
              </label>
            </IconButton>
          </label>
        </div>
      </div>
      {/* Title */}
      <div className="control_group w_50">
        <label>Title</label>
        <TextField
          variant="outlined"
          placeholder="Title"
          fullWidth
          hiddenLabel
          className="text_field"
          name="title"
          id="title"
          inputProps={{ maxLength: 80 }}
          value={formik.values.title}
          onChange={(val) => {
            if (isValidInput(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.title && formik.errors.title}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>
      {/* Brand */}
      <div className="control_group w_50">
        <label>Select Brand</label>
        <Select
          fullWidth
          labelId="brandId"
          name="brandId"
          value={masterData?.brand?.length ? formik.values.brandId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.brandId && Boolean(formik.errors.brandId)}
        >
          <MenuItem disabled value="default">
            Select Brand
          </MenuItem>
          {masterData?.brand?.length
            ? masterData?.brand?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.brand?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No brands found'}
        </Select>
        <FormHelperText error>{formik.touched.brandId && formik.errors.brandId}</FormHelperText>
      </div>
      {/* Model */}
      <div className="control_group w_50">
        <label>Select Model</label>
        <Select
          fullWidth
          labelId="modelId"
          name="modelId"
          value={masterData?.vehicleModel?.length ? formik.values.modelId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.modelId && Boolean(formik.errors.modelId)}
        >
          <MenuItem disabled value="default">
            Select Model
          </MenuItem>
          {masterData?.vehicleModel?.length
            ? masterData?.vehicleModel?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.vehicleModel?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No models found'}
        </Select>
        <FormHelperText error>{formik.touched.modelId && formik.errors.modelId}</FormHelperText>
      </div>
      {/* Body Type */}
      <div className="control_group w_50">
        <label>Select Body Type</label>
        <Select
          fullWidth
          labelId="bodyType"
          id="bodyType"
          value={bodyType}
          onChange={handleBodyTypeChange}
        >
          <MenuItem disabled value="default">
            Select Body Type
          </MenuItem>
          <MenuItem value={1}>Supersport</MenuItem>
          <MenuItem value={2}>Sport Touring</MenuItem>
          <MenuItem value={3}>Chopper Cruiser</MenuItem>
          <MenuItem value={3}>Street fighter</MenuItem>
        </Select>
      </div>
      {/* Mileage */}
      <div className="control_group w_50">
        <label>Mileage</label>
        <TextField
          variant="outlined"
          placeholder="Mileage"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>
      {/* Year */}
      <div className="control_group w_50">
        <label>Year</label>
        <TextField
          variant="outlined"
          placeholder="Year"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>

      {/* Fuel Type */}
      <div className="control_group w_50">
        <label>Select Fuel Type</label>
        <Select
          fullWidth
          labelId="fuelType"
          id="fuelType"
          value={fuelType}
          onChange={handleFuelType}
        >
          <MenuItem disabled value="default">
            Select Fuel Type
          </MenuItem>
          <MenuItem value={1}>Petrol</MenuItem>
          <MenuItem value={2}>Diesel</MenuItem>
          <MenuItem value={3}>Gasoline</MenuItem>
        </Select>
      </div>
      {/* Seats */}

      {/* Drive type */}
      <div className="control_group w_50">
        <label>Select Final Drive System</label>
        <Select
          fullWidth
          labelId="driveType"
          id="driveType"
          value={driveType}
          onChange={handleDriveType}
        >
          <MenuItem disabled value="default">
            Select Final Drive System
          </MenuItem>
          <MenuItem value={1}>Chain </MenuItem>
          <MenuItem value={2}>Belt</MenuItem>
          <MenuItem value={3}>Shaft</MenuItem>
        </Select>
      </div>
      {/* Transmission */}
      {/* <div className="control_group w_50">
        <label>Select Transmission Type</label>
        <Select
          fullWidth
          labelId="transmissionType"
          id="transmissionType"
          value={transmissionType}
          onChange={handleTransmissionType}
        >
          <MenuItem disabled value="default">
            Select Transmission Type
          </MenuItem>
          <MenuItem value={1}>Manual Transmission </MenuItem>
          <MenuItem value={2}>Automatic Transmission</MenuItem>
        </Select>
      </div> */}
      {/*  Power */}
      {/* <div className="control_group w_50">
        <label>Select Power</label>
        <Select
          fullWidth
          labelId="power"
          id="power"
          value={power}
          onChange={handlePowerChange}
        >
          <MenuItem disabled value="default">
            Select Power
          </MenuItem>
          <MenuItem value={1}>55 Kw (75 hp) </MenuItem>
          <MenuItem value={2}>65 Kw (88 hp)</MenuItem>
          <MenuItem value={2}>66 Kw (90 hp)</MenuItem>
          <MenuItem value={2}>74 Kw (101 hp)</MenuItem>
        </Select>
      </div> */}
      {/* Engine Size */}
      <div className="control_group w_50">
        <label>Engine Size</label>
        <Select
          fullWidth
          labelId="engineCapacity"
          id="engineCapacity"
          value={engineCapacity}
          onChange={handleEngineCapacity}
        >
          <MenuItem disabled value="default">
            Select Engine Size
          </MenuItem>
          <MenuItem value={1}>Less than 250 </MenuItem>
          <MenuItem value={2}>250 - 499 cc</MenuItem>
          <MenuItem value={2}>500 - 599 cc</MenuItem>
          <MenuItem value={2}>600 - 749 cc</MenuItem>
        </Select>
      </div>

      {/* Color */}
      <div className="control_group w_50">
        <label>Select Color</label>
        <Select
          fullWidth
          labelId="exteriorColor"
          id="exteriorColor"
          value={exteriorColor}
          onChange={handleExteriorColor}
        >
          <MenuItem disabled value="default">
            Select Color
          </MenuItem>
          <MenuItem value={1}>Black </MenuItem>
          <MenuItem value={2}>White</MenuItem>
          <MenuItem value={3}>Red</MenuItem>
          <MenuItem value={4}>Blue</MenuItem>
          <MenuItem value={5}>Yellow</MenuItem>
        </Select>
      </div>
      {/* Price */}
      <div className="control_group w_50">
        <label>Final Price</label>
        <TextField
          variant="outlined"
          placeholder="Final Price"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>
      {/* Warranty */}
      <div className="control_group w_50">
        <label>Warranty</label>
        <Select
          fullWidth
          labelId="warranty"
          id="warranty"
          value={warranty}
          onChange={handleWarrantyChnage}
        >
          <MenuItem disabled value="default">
            Warranty
          </MenuItem>
          <MenuItem value={1}>Yes </MenuItem>
          <MenuItem value={2}>No</MenuItem>
          <MenuItem value={2}>Does not apply</MenuItem>
        </Select>
      </div>

      {/* Features */}
      <div className="control_group w_50">
        <label>Equipments</label>

        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={carFeatures}
          onChange={(event, newValue) => {
            setFeatures(newValue);
          }}
          value={features}
          disableCloseOnSelect
          filterSelectedOptions
          limitTags={2}
          getOptionLabel={(option) => option?.name || ''}
          className="autocomplete"
          renderInput={(params) => (
            <TextField
              variant="outlined"
              hiddenLabel
              {...params}
              placeholder={features.length === 0 ? 'Select Equipments' : ''}
            />
          )}
        />
      </div>

      {/* Location */}
      <div className="control_group w_50">
        <label>Location</label>
        <TextField
          variant="outlined"
          placeholder="Location"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>
      {/* City */}
      <div className="control_group w_50">
        <label>City</label>
        <TextField
          variant="outlined"
          placeholder="City"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>
      {/* Area */}
      <div className="control_group w_50">
        <label>Area</label>
        <TextField
          variant="outlined"
          placeholder="Area"
          fullWidth
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
                <h6 className="err_msg">Name is required</h6>
              ) : (
                ""
              )} */}
      </div>

      {/* Description */}
      <div className="control_group w_50">
        <label>Bike Description</label>
        <TextField
          variant="outlined"
          placeholder="Bike Description"
          fullWidth
          multiline
          minRows={3}
          maxRows={4}
          hiddenLabel
          // value={fullName}
          // onChange={(e) => setFullName(e.target.value)}
        />
        {/* {error && fullName == "" ? (
               <h6 className="err_msg">Name is required</h6>
             ) : (
               ""
             )} */}
      </div>
    </>
  );
};

export default BikeForm;
